import { isProduction } from '../utils/utils';

export const OAUTH2_CLIENT_ID_PROD =
  '546584498403-snvknu3h3pbh270lcnr3r88gedpi2vic.apps.googleusercontent.com';
export const OAUTH2_CLIENT_ID_DEV =
  '1050715551196-b1gn63jaqv5t1503recv9ovlom52s5v3.apps.googleusercontent.com';

export const getClientID = () =>
  isProduction() ? OAUTH2_CLIENT_ID_PROD : OAUTH2_CLIENT_ID_DEV;
